import { IComponentOptions } from "angular";
import { LookupManagementComponentController } from "./controller";

export const vsComponentName = "lookupManagement";

export const lookupManagementComponentOptions: IComponentOptions = {
  controller: LookupManagementComponentController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    initialType: "<",
  },
};
